/** When your routing table is too long, you can split it into small modules**/
const noticesRouter = {
  path: '/notices',
  name: 'Notices',
  component: () => import('@/views/notices/Index.vue'),
  meta: {
    title: '消息通知'
  },
}

export default noticesRouter
